import { ExtractComponentProp } from '@approvalmax/types';
import { DatePicker } from '@approvalmax/ui/src/components';
import moment from 'moment';
import { useCallback, useMemo } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { useGetStandaloneRequestCurrencies } from 'shared/data/webApp/v2';
import { z } from 'zod';

import { mapCurrenciesToSelectItems } from './MainSection.helpers';
import { schema } from './MainSection.schema';

export const useCurrency = (props: { companyId: string; requestId: string; currencyCode: string }) => {
    const { companyId, requestId, currencyCode } = props;

    const { data, isLoading } = useGetStandaloneRequestCurrencies(
        {
            path: { companyId, requestId },
        },
        { staleTime: Infinity }
    );

    const currencies = useMemo(() => mapCurrenciesToSelectItems(data?.currencies), [data?.currencies]);

    const isCrypto = useMemo(() => {
        const currentCurrency = data?.currencies.find(({ code }) => code === currencyCode);

        return currentCurrency?.isCrypto ?? false;
    }, [data?.currencies, currencyCode]);

    return { isCrypto, currencies, isLoadingCurrencies: isLoading };
};

export const useDateChange = (setValue: UseFormSetValue<z.infer<typeof schema>>) => {
    return useCallback<ExtractComponentProp<typeof DatePicker, 'onChange'>>(
        (value) => {
            setValue('date', value ? moment(value).format('YYYY-MM-DD') : null);
        },
        [setValue]
    );
};
